// Keep the chat frame inside the visible viewport. iOS can pan that viewport
// without resizing the layout viewport when its keyboard appears.
export const installChatViewport = () => {
  const root = document.documentElement
  const viewport = window.visualViewport
  let frame = null
  let settle = null
  let baseline = window.innerHeight
  let width = window.innerWidth
  let lastHeight = 0
  let disposed = false
  const editable = () => document.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]')
  const update = () => {
    frame = null
    if (disposed || !document.body.classList.contains('chat-page-active')) return
    // Preserve ordinary pinch zoom; it must not continuously relayout chat.
    if (viewport && Math.abs((viewport.scale || 1) - 1) > 0.05) return
    const height = Math.max(1, viewport?.height || window.innerHeight)
    const top = Math.max(0, viewport?.offsetTop || 0)
    if (Math.abs(window.innerWidth - width) > 40) { width = window.innerWidth; baseline = Math.max(window.innerHeight, height) }
    if (!editable()) baseline = Math.max(height, window.innerHeight)
    const keyboard = Boolean(editable() && Math.max(baseline, window.innerHeight) - height > 100)
    root.style.setProperty('--chat-viewport-height', `${height}px`)
    root.style.setProperty('--chat-viewport-top', `${top}px`)
    document.body.classList.toggle('chat-keyboard-open', keyboard)
    window.dispatchEvent(new CustomEvent('chat-viewport-change', { detail: { height, top, keyboard, previousHeight: lastHeight } }))
    lastHeight = height
  }
  const schedule = () => { if (!disposed && frame === null) frame = requestAnimationFrame(update) }
  const focus = () => { schedule(); clearTimeout(settle); settle = setTimeout(schedule, 350) }
  viewport?.addEventListener('resize', schedule)
  viewport?.addEventListener('scroll', schedule)
  window.addEventListener('resize', schedule)
  window.addEventListener('chat-viewport-refresh', schedule)
  document.addEventListener('focusin', focus)
  document.addEventListener('focusout', focus)
  schedule()
  return () => {
    disposed = true
    if (frame !== null) cancelAnimationFrame(frame)
    clearTimeout(settle)
    viewport?.removeEventListener('resize', schedule)
    viewport?.removeEventListener('scroll', schedule)
    window.removeEventListener('resize', schedule)
    window.removeEventListener('chat-viewport-refresh', schedule)
    document.removeEventListener('focusin', focus)
    document.removeEventListener('focusout', focus)
    document.body.classList.remove('chat-keyboard-open')
    root.style.removeProperty('--chat-viewport-height')
    root.style.removeProperty('--chat-viewport-top')
  }
}
